<template>
  <v-card style="width: 80%; margin: auto; margin-top: 2rem;">
    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="fullname" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Department Name : </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search by name" single-line outlined
            hide-details dense></v-text-field>

          <v-spacer></v-spacer>
          <v-btn color="#0A7EA5" rounded dark v-bind="attrs" v-on="on" @click="openadd()" :disabled="!authorize_add"
            style="margin: auto;">
            Add Department
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="openeditItem(item)" v-if="authorize_edit">
          mdi-pencil
        </v-icon>
        <!-- <v-icon small @click="deleteItem(item)" v-if="authorize_del">
          mdi-delete
        </v-icon> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogadd" max-width="500px">
      <v-card style="padding: 1rem 0.5rem;">
        <v-card-title class="text-h5" style="margin-bottom: 1rem;">Add Department</v-card-title>
        <v-card-text style="padding-bottom: 0;">
          <v-container>
            <v-row style="margin-bottom: 1rem;">
              <v-text-field v-model="itemadd.name" label="Department Name" outlined
                style="height: 55px;"></v-text-field>
            </v-row>
            <v-row style="margin-bottom: 1rem;">
              <v-select v-validate="'required'" :items="companyAll" label="Company" item-text="name" item-value="id"
                v-model="itemadd.company_id" outlined @change="changeSPGroupMenu" required :rules="commonRules"
                style="height: 55px;"></v-select>
            </v-row>
            <!-- <v-row style="margin-bottom: 1rem;">
          

              <v-autocomplete
                style="height: 55px;"
                v-validate="'required'"
                required
                outlined
                :rules="commonRules"
                v-model="itemadd.acc_email"
                :items="userAccount"
                item-text="name"
                item-value="email"
                label="User Account Timesheet Auto Report"
                filled
                @change="changeSPUserAccount"
                clearable
                @click:clear="
                  $nextTick(() => {
                    itemadd.acc_email = '';
                  })
                "
              ></v-autocomplete>
            </v-row> -->
          </v-container>
        </v-card-text>

        <v-card-actions class="d-flex justify-center">
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="savedata()">
            Save
          </v-btn>
          <v-btn depressed outlined width="100" @click="canceladd()">
            Cancel
          </v-btn>
          <!-- <v-btn color="red darken-1" text @click="canceladd()">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="savedata()">Save</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogedit" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Edit Department</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="itemedit.name" label="Department Name" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin-top: -30px;">
              <v-col cols="12" sm="12" md="12">
                <v-select v-validate="'required'" :items="companyAll" label="Company" item-text="name" item-value="id"
                  v-model="itemedit.company_id" outlined @change="changeSPGroupMenu" required
                  :rules="commonRules"></v-select>
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">


                <v-autocomplete
                  v-validate="'required'"
                  required
                  outlined
                  :rules="commonRules"
                  v-model="itemedit.acc_email"
                  :items="userAccount"
                  item-text="name"
                  item-value="email"
                  label="User Account Timesheet Auto Report"
                  filled
                  @change="changeSPUserAccount"
                  clearable
                  @click:clear="
                    $nextTick(() => {
                      itemedit.acc_email = '';
                    })
                  "
                ></v-autocomplete>
              </v-col>
            </v-row> -->
          </v-container>
        </v-card-text>

        <v-card-actions class="d-flex justify-center" style="margin-top: -40px; padding-bottom: 20px;">
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="savedataedit()">
            Save
          </v-btn>
          <v-btn depressed outlined width="100" @click="canceledit()">
            Cancel
          </v-btn>
          <!-- <v-btn color="blue darken-1" text @click="canceledit()">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="savedataedit()">Save</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
  </v-card>
</template>
<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
export default {
  components: {
    SuccessDialog,
  },
  data: () => ({
    userAccount: [],
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    search: "",
    dialogadd: false,
    dialogedit: false,
    headers: [
      { text: "ID", value: "id" },
      { text: "Department Name", value: "department_name" },
      // { text: "address", value: "address" },
      // { text: "provice", value: "provice" },
      // { text: "zipcode", value: "zipcode" },
      { text: "Company Name", value: "company_name" },

      { text: "Status", value: "status" },
      { text: "Action", value: "actions" },
    ],
    desserts: [],
    itemadd: {
      name: "",
      company_id: "",
      acc_email: "",
    },
    itemeditid: 0,
    itemedit: {
      name: "",
      company_id: "",
      acc_email: "",
    },
    companyAll: [],
  }),
  async mounted() {
    await api.checkVersion();
    // ----------------- Check Authorize ---------------------------
    const userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let token = localStorage.getItem(server.USER_ID);

    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    this.$showLoader();
    await this.loadAccounts();
    await this.loadCompany();
    await this.getcompanydata();
    this.$hideLoader();
  },
  methods: {
    changeSPUserAccount(selectObj) {
      console.log("changeSPUserAccount selectObj:" + selectObj);

      if (selectObj == "" || selectObj == null) {
        this.itemadd.acc_email = "";
        this.itemedit.acc_email = "";

        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "User Account Not Found Email ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async loadAccounts() {
      try {
        const resultList = await api.getAccountslist_by_ComID(
          localStorage.getItem(server.COMPANYID)
        );

        this.userAccount = resultList?.data || [];
      } catch (err) {
        console.error(err);

        this.userAccount = []; // กันพัง

        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Error",
          err?.response?.data?.message || "Load data failed",
          "text-h5 red--text text-center"
        );
      }

    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async loadCompany(id) {
      try {
        const result = await api.getCompanyByID(localStorage.getItem(server.COMPANYID));
        this.companyAll = result?.data || [];
      } catch (err) {
        console.error(err);

        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Error",
          err?.response?.data?.message || "Something went wrong",
          "text-h5 red--text text-center"
        );
      }
    },
    async getcompanydata() {
      try {
        const result = await api.getNewAllDepartment_By_CompanyID(
          localStorage.getItem(server.COMPANYID)
        );

        this.desserts = result?.data || [];
      } catch (err) {
        console.error(err);

        this.desserts = []; // กัน UI พัง

        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Error",
          err?.response?.data?.message || "Load data failed",
          "text-h5 red--text text-center"
        );
      }
    },

    openadd() {
      this.itemadd = {
        name: "",
        company_id: "",
      };
      this.dialogadd = true;
    },
    canceladd() {
      this.dialogadd = false;
    },
    canceledit() {
      this.dialogedit = false;
    },
    async savedata() {
      if (this.itemadd.name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Department Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemadd.company_id == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Company",
          "text-h5 red--text text-center"
        );
        return;
      }
      const res_add = await api.addDepartment(this.itemadd);
      if (res_add.status == 200) {
        if (this.itemadd.company_id == 1) {
          const res_add_smemate = await api.addDepartmentSME(res_add.data);
          if (res_add_smemate.status == 200 || res_add_smemate.status == 201) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Success",
              "Add data success",
              "text-h5 green--text text-center"
            );
            this.getcompanydata();
          }
          else {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Add data Failed",
              "text-h5 red--text text-center"
            );
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Add data success",
            "text-h5 green--text text-center"
          );
          this.getcompanydata();
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Add data Failed",
          "text-h5 red--text text-center"
        );
      }
      this.dialogadd = false;
    },

    async openeditItem(item) {
      console.log("============================");
      console.log(item);
      this.itemeditid = item.id;
      this.itemedit.name = item.department_name;
      this.itemedit.company_id = item.company_id;
      this.itemedit.acc_email = item.acc_email;
      this.dialogedit = true;
    },
    async savedataedit() {
      if (this.itemedit.name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Department Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemedit.company_id == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select Company",
          "text-h5 red--text text-center"
        );
        return;
      }
      const res_update = await api.updateDepartment(
        this.itemeditid,
        this.itemedit
      );
      if (res_update.status == 200 || res_update.status == 201) {
        if (this.itemedit.company_id == 1) {
          const res_update_smemate = await api.updateDepartmentSME(this.itemeditid, this.itemedit);
          console.log(res_update_smemate);
          if (res_update_smemate.status == 200 || res_update_smemate.status == 201) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Success",
              "Update data success",
              "text-h5 green--text text-center"
            );
            this.getcompanydata();
          }
          else {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Update data Failed",
              "text-h5 red--text text-center"
            );
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Update data success",
            "text-h5 green--text text-center"
          );
          this.getcompanydata();
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Update data Failed",
          "text-h5 red--text text-center"
        );
      }
      this.dialogedit = false;
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>
